module.exports = __webpack_public_path__ + "img/BlockOutlined.7922a819.svg";